<template>
    <div class="scanning-rod" @mousedown="onMouseDown">
        <div class="rod-title">{{ rodTitle }}</div>
        <xl-form :model="rodFormData" label-position="left" label-width="166px">
            <xl-form-item prop="company" :label="$t('design.preference.company') || '公司'">
                <xl-select class="select-width" v-model="rodFormData.company" options="" 
                    @change="handleCompanyChange" :placeholder="$t('design.preference.selectPlaceholder')" clearable filterable>
                    <xl-option :label="item.company" :value="item.company" v-for="(item, index) in allCompanyList" :key="index"></xl-option>
                </xl-select>
            </xl-form-item>
            <xl-form-item prop="brand" :label="$t('design.preference.brand') || '品牌'">
                <xl-select class="select-width" v-model="rodFormData.brand" options=""
                    @change="handleBrandChange" :placeholder="$t('design.preference.selectPlaceholder')" clearable filterable>
                    <xl-option :label="item.name" :value="item.name" v-for="item in rodBrandList" :key="item.id"></xl-option>
                </xl-select>
            </xl-form-item>
            <xl-form-item prop="type" :label="$t('design.preference.type') || '类型'">
                <xl-select class="select-width" v-model="rodFormData.type" options=""
                    @change="handleTypeChange" :placeholder="$t('design.preference.selectPlaceholder')" clearable filterable>
                    <xl-option :label="item.name" :value="item.name" v-for="item in rodTypeList" :key="item.name"></xl-option>
                </xl-select>
            </xl-form-item>
            <xl-form-item prop="attachmentType" :label="$t('design.preference.attachmentType') || '附属类型'">
                <xl-select class="select-width" v-model="rodFormData.attachmentType" options=""
                    @change="handleAttachmentTypeChange" :placeholder="$t('design.preference.selectPlaceholder')" clearable filterable>
                    <xl-option :label="item.name" :value="item.name" v-for="item in rodAttachmentList" :key="item.name"></xl-option>
                </xl-select>
            </xl-form-item>
            <xl-form-item prop="details" :label="$t('design.preference.dataBaseModel') || '数据库模型'" class="model-label">
                <div class="model-box" ref="iframeRef">
                    <div v-show="displayData" class="thumbnail">
                        <div class="iframe-body" 
                            :element-loading-text="`${$t('design.loading')}...`" element-loading-background="#f5f6f8">
                            <iframe class="three-d-model" title="" :id="iframeId"></iframe>
                        </div>
                    </div>

                    <no-data v-show="!displayData" :text="`${$t('design.preference.notSelectedRod')}`"></no-data>
                </div>
            </xl-form-item>
        </xl-form>

        <xl-form v-if="props.selectProduct === 'prod_guided_implant_surgery'" :model="guidedFormData" class="tool-box" label-position="left" label-width="166px">
            <xl-form-item prop="company" :label="$t('design.preference.toolboxBrand') || '工具盒品牌'">
                <xl-input class="select-width" v-model="guidedFormData.toolboxBrand" :placeholder="$t('design.preference.inputPlaceholder') || '请输入内容'"></xl-input>
            </xl-form-item>
            <xl-form-item prop="company" :label="$t('design.preference.toolboxSeries') || '工具盒系列'">
                <xl-input class="select-width" v-model="guidedFormData.toolboxSeries" :placeholder="$t('design.preference.inputPlaceholder') || '请输入内容'"></xl-input>
            </xl-form-item>
        </xl-form>
    </div>
</template>

<script setup>
import {
    XlForm,
    XlFormItem,
    XlCol,
    XlRow,
    XlSelect,
    XlMessage,
    XlLoading,
    XlInput,
    XlOption
} from "@shining3d/ui-components";
import { ref, watch, nextTick, defineEmits, computed, onMounted } from 'vue'
import noData from '../../../components/no-data.vue'
import use3dView from '../utils/3dView.js';
import { useLang } from "@shining3d/common-module/utils/lang.js";
import { $getCdnUrl } from '../../../utils/common.js';
import { cloneDeep } from 'lodash';
import preferenceApi from '../../../api/preference';
import _get from 'lodash/get';
import store from '@/store';

const props = defineProps({
    selectProduct: {
        type: String,
    },
    scanningData: {
        type: Object
    },
    implantSurgeryData: {
        type: Object
    },
})
const { $t } = useLang("@shining3d/xl-design-order");
const orgID = computed(() => _get( store, 'state.factorySelect.id', ''));
const initRodFormData = {
    company: '', //公司
    brand: '', //品牌
    type: '', //类型
    attachmentType: '', //附属类型
    // toolboxBrand: '', //工具盒品牌
    // toolboxSeries: '', //工具盒系列
}
const systemID = ref('');
const selectModelID = ref('')
const initGuidedFormData = {
    toolboxBrand: '', //工具盒品牌
    toolboxSeries: '', //工具盒系列
}
const rodFormData = ref( cloneDeep( initRodFormData ));
const guidedFormData = ref( cloneDeep( initGuidedFormData ));
const iframeRef = ref(null);
const modelLoading = ref(false);
const iframeId = 'thumbnail-frame' + new Date().getTime();
const clientInfo = {
    container: iframeId,
    loading: false,
    background: '#F6F7F9',
    url: _get(window, 'app.global.threeDModelDentalPartsUrl')
};
const { isLoading, Client: myClient } = use3dView(clientInfo);
// 模型是否有选中数据
const displayData = ref(null);
let currentModelId = null;
// 扫描杆数据-公司下拉列表
const rodCompanyList = ref([])
// 扫描杆数据-品牌下拉列表
const rodBrandList = ref([])
// 扫描杆数据-类型下拉列表
const rodTypeList = ref([])
// 扫描杆数据-附属类型下拉类别
const rodAttachmentList = ref([])

// 扫描杆 品牌、类型、附属类型数据
const rodList = ref([]);
// 获取扫描杆所有公司列表
const allCompanyList = ref([]);
// 获取扫描杆公司
const dentalScanningRodSystemBrandList = async (systemType) => {
    const res =  await preferenceApi.dentalScanningRodSystemBrandList({ factoryID: orgID.value, systemType: systemType, origin: 'dentalx' })
    if( res && res.status ==='success' ){
        if ( res.result && Array.isArray( res.result )) {
            allCompanyList.value = res.result || [];
        }
    }
}

// 获取扫描杆替换数据-类型、附属类型数据
const getScannerRodSystemList = async (BrandId) => {
    const res =  await preferenceApi.dentalScanningRodSystemList({ factoryID: orgID.value, systemType: systemType.value, companyID: BrandId, origin: 'dentalx' });
    if( res && res.status ==='success' ){
            if ( res.result && Array.isArray( res.result )) {    
                if( res.result.length ){
                    return res.result[0]?.values?.find((item) => item?.systemID === BrandId )
                    
                    // return res.result[0]?.values?.find((item) => item?.systemID === BrandId )
                }
            }
    }
}
// 切换公司
const handleCompanyChange = () => {
    rodFormData.value.brand = '';
    rodFormData.value.type = '';
    rodFormData.value.attachmentType = '';
    systemID.value = '';
    // rodBrandList.value = rodCompanyList.value.find((item) => item.name === rodFormData.value.company )?.values || [];
    rodBrandList.value = allCompanyList.value.find((item) => item.company === rodFormData.value.company )?.systems || [];
    handleDeleteModel();
}
// 切换品牌
const handleBrandChange = async(value) => {
    rodFormData.value.type = '';
    rodFormData.value.attachmentType = '';
    systemID.value = rodBrandList.value?.find((item) => item.name === value)?.id || ''
    const data = await getScannerRodSystemList(systemID.value);
    // const data = rodBrandList.value.find((item) => item.name === rodFormData.value.brand );
    if( data?.values ){
        rodTypeList.value = data.values || [];
    } else if( rodFormData.value.brand ){
        rodTypeList.value = [];
        XlMessage({ type: 'warning', message: $t('design.noData') });
    }
    handleDeleteModel();
}
// 切换类型
const handleTypeChange = () => {
    rodFormData.value.attachmentType = '';
    const data = rodTypeList.value.find((item) => item.name === rodFormData.value.type );
    if ( data?.values ){
        handleDeleteModel();
        rodAttachmentList.value = data.values || [];
    } else {
        rodAttachmentList.value = [];
        handleDataItem(data);
    }
}
// 切换附属类型
const handleAttachmentTypeChange = () => {
    const data = rodAttachmentList.value.find((item) => item.name === rodFormData.value.attachmentType );
    handleDataItem(data);
}
const handleDataItem = (data) => {
    selectModelID.value = '';
    if (!data) {
        return;
    }
    currentModelId && myClient.deleteModels([currentModelId]);
    if (data?.bucket && data?.dfsID) {
        displayData.value = data;
        data.url = $getCdnUrl({ bucket: data.bucket, dfsID: data.dfsID });
        const originData = {
            id: data.dfsID,
            url: data.url,
            visible: true,
            type: 'dentalParts'
        };
        currentModelId = data.dfsID;
        setTimeout(() => {
            nextTick(() => {
                myClient.init([originData]);
            })
        },500)
        selectModelID.value = data?.systemID || '';
        
    } else {
        XlMessage({ type: 'warning', message: $t('design.noData') });
    }
};
// 清除扫描杆模型
const handleDeleteModel = () => {
    displayData.value = null;
}

const emits = defineEmits(['itemMouseDown', 'changeRodDefault'])
const onMouseDown = () => {
    emits('itemMouseDown')
}
watch(isLoading, (newVal, oldVal) => {
    // nextTick(() => {
        if (!newVal) {
            myClient.onViewChange('fortyFiveView');
            if (iframeRef.value && modelLoading.value) {
                modelLoading.value?.close();
            }
        } else if (iframeRef.value) {
            modelLoading.value = XlLoading.service({
                target: iframeRef.value,
                text: $t('design.loading') + '...',
                background: 'transparent',
            });
        }
    // })
}, { immediate: true });
const defaultData = ref({});
// 数据库标题
const rodTitle = ref('')
const systemType = ref('');
const rodProductList = ['prod_guided_implant_surgery', 'prod_3D_implant_model', 'prod_customized_implant_abutments', 'prod_malo_bridge', 'prod_implant_crown', 'prod_implant_coping', 'prod_implant_allonx']
watch(() => props.scanningData, async (val) => {
    // if(val){
        // displayData.value = null
        defaultData.value = cloneDeep(val);
        // rodFormData.value.company = ''
        // rodFormData.value.brand = ''
        // rodFormData.value.type = ''
        // rodFormData.value.attachmentType = ''
        // let systemType = '';
        systemType.value = '';

        if( rodProductList.includes( props.selectProduct )){
            if( props.selectProduct === 'prod_guided_implant_surgery'){
                systemType.value = 'implantSystem'
                rodTitle.value = $t('design.preference.implantDatabase') || '植体数据库'
                // getScannerRodSystemList(systemType);
                await dentalScanningRodSystemBrandList(systemType.value);
            } else {
                systemType.value = 'commonSystem'
                rodTitle.value = $t('design.preference.rodDatabase') || '扫描杆数据库'
                // getScannerRodSystemList(systemType);
                await dentalScanningRodSystemBrandList(systemType.value);
            }
        }
        // const companyObj = rodCompanyList.value?.find((item) => item.name === val?.company)
        const companyObj = allCompanyList.value?.find((item) => item.company === val?.company)
        rodFormData.value.company = companyObj ? (val?.company || '') : ''
        const brandList = companyObj?.systems || [];
        const brandObj = brandList?.find((item) => item.name === val?.brand)
        rodFormData.value.brand = brandObj ? (val?.brand || '') : ''
        systemID.value = brandObj ? (brandObj?.id || '') : ''
        if( !companyObj || !brandObj ){
            rodFormData.value.brand = ''
            rodFormData.value.type = ''
            rodFormData.value.attachmentType = ''
            defaultData.value = {
                company: rodFormData.value.company || '',
                brand: '',
                type: '',
                attachmentType: ''
            }
        } else {
            rodFormData.value.type = val?.type || ''
            rodFormData.value.attachmentType = val?.attachmentType || ''
        }
    // } 
}, {immediate: true, deep: true});

const changeData = () => {
    let flag = false;
    Object.keys(rodFormData.value)?.forEach(key => {
        if( rodFormData.value[key] !== defaultData.value[key] ){
            flag = true;
        }
    }) 
    return flag;
}
watch(() => props.implantSurgeryData, (val) => {
    if(val){
        guidedFormData.value.toolboxBrand = val?.toolboxBrand || ''
        guidedFormData.value.toolboxSeries = val?.toolboxSeries || ''
    }
}, {immediate: true, deep: true});
watch(() => rodFormData.value.company, (val) => {
    if( val ){
        // rodBrandList.value = rodCompanyList.value.find((item) => item.name === val )?.values || [];
        rodBrandList.value = allCompanyList.value.find((item) => item.company === rodFormData.value.company )?.systems || [];
        // handleDeleteModel();
    } else {
        rodBrandList.value = [];
    }
}, { immediate: true, deep: true });
watch(() => rodFormData.value.brand, (val) => {
    if( !val ){
        rodTypeList.value = [];
    } else {
        systemID.value = rodBrandList.value?.find((item) => item.name === val)?.id || ''
    }
}, { immediate: true, deep: true });

watch(() => rodFormData.value.type, async (val) => {
    if( val ){
        const brandData = await getScannerRodSystemList(systemID.value);
        // if( brandData )
        rodTypeList.value = brandData?.values || [];
        const data = rodTypeList.value.find((item) => item.name === val );
        if ( data?.values ){
            // handleDeleteModel();
            rodAttachmentList.value = data.values || [];

            if( rodFormData.value.attachmentType ){
                const data = rodAttachmentList.value.find((item) => item.name === rodFormData.value.attachmentType );
                handleDataItem(data);
            } else {
                handleDeleteModel();
            }
        } else {
            rodAttachmentList.value = [];
            handleDataItem(data);
        }
    } else {
        rodAttachmentList.value = [];
        handleDeleteModel();
    }
}, { immediate: true, deep: true });
// watch(() => rodFormData.value.attachmentType, (val) => {
//     if( val ){
//         const data = rodAttachmentList.value.find((item) => item.name === rodFormData.value.attachmentType );
//         handleDataItem(data);
//     } else {
//         displayData.value = null
//     }
// }, { immediate: true, deep: true })
// const init = () => {
//     if (defaultCompany.value && defaultBrand.value && defaultType.value && defaultAttachmentType.value) {
//         handleDataItem({
//             bucket: 't-pubhz',
//             dfsID: 'scanningRod/0c62a802-556d-557d-9c12-70d673c7fefe/preview_gltf/48de0d8d-aaff-520c-bc68-292accf24e04.gltf'
//         });
//     } else {
//         displayData.value = null;
//     }
// };
// init();

defineExpose({ rodFormData, guidedFormData, selectModelID, changeData, defaultData });
</script>

<style lang="scss" scoped>
.scanning-rod {
    font-family: "Alibaba PuHuiTi 2.0";
    margin-right: 16px;
    // margin-top: 16px;
    // padding-top: 16px;
    // border-top: 1px dashed #E0E4EA;
    .select-width {
        width: 204px;
    }

    :deep(.el-form-item) {
        margin-bottom: 8px !important;
    }

    :deep(.el-form-item__label) {
        font-size: 14px;
        font-weight: 500;
        color: #42526e;
    }

    .model-box {
        // width: 120px;
        width: 204px;
        // margin-left: 80px;
        height: 132px;
        border-radius: 6px;
        display: flex;
        justify-content: flex-end;

        .thumbnail {
            // width: 120px;
            width: 204px;
            height: 132px;
            background-color: $bg-card-color;
            border-radius: 6px;

            .iframe-body {
                width: 100%;
                height: 100%;
                position: relative;
                line-height: 0;

                :deep(.el-loading-text) {
                    line-height: 1.5;
                    font-size: 12px;
                    margin-top: 4px;
                }
            }

            .three-d-model {
                user-select: none; // 防止选中出现蒙层
                border: none;
                width: 100%;
                height: 100%;
                border-radius: 6px;
            }

            img {
                width: 100%;
                height: 100%;
            }
        }
    }

    .model-label {
        height: 132px !important;
        display: flex;
        align-items: center;
    }

    :deep(iframe#thumbnail-frame) {
        width: 120px;
        height: 132px;
    }
    .tool-box{
        margin-top: 16px;
        padding-top: 16px;
        border-top: 1px dashed #E0E4EA;
        :deep(.el-form-item__label){
            line-height: normal;
            display: flex;
            align-items: center;
        }
    }
    .rod-title{
        font-size: 12px;
        font-weight: 500;
        font-family: $font-family65;
        color: #A5ACBE;
        margin-bottom: 12px;
    }
}
</style>
